// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FucL","colMin":"styles_colMin__1kFRI","colCheckbox":"styles_colCheckbox__1IAiD"};